import { render, staticRenderFns } from "./Col.vue?vue&type=template&id=2c0f70cc&"
import script from "./Col.vue?vue&type=script&lang=js&"
export * from "./Col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports